import React, { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import parse from 'html-react-parser'
import { useDialogSelector } from '../store/selectors/dialogSelector'
import { ACTIONS, URLS } from '../_config'
import Icon from './icons'
import Button from './elements/button'

const Dialog: React.FC = () => {
    const dispach = useDispatch()
    const dialog: any = useDialogSelector()
    const dialogModal: any = useRef()
 
    useEffect(() => {
        if (dialog != null) {
            dialogModal.current?.showModal()
        } else {
            dialogModal.current?.close()
        }
    }, [dialog])
 
    const close = () => {
        dialogModal.current?.close()
    }
    return (
        <dialog
            ref={dialogModal}
            className="modal"
            onClose={() => {
                dispach({ type: ACTIONS.DIALOG, payload: null })
            }}
        >
            <div className="modal-box">
                {dialog?.dialog == 'confirm' && (
                    <>
                        {dialog?.type == 'delete' && (
                            <>
                                <p className="font-bold text-center text-[1.333rem] leading-8">{dialog.title}</p>
                                <p className="py-4 text-center">{parse(dialog.message)}</p>
                                {dialog.warning && (
                                    <div className="mb-8 bg-[#FFE9D9] rounded-[0.333rem] text-center overflow-hidden px-4 py-2">
                                        <div className="flex items-center text-[#F23F44] justify-center mb-1">
                                            <Icon name="warning" />
                                            <p className="!text-[#F23F44] text-[0.75rem] font-bold">
                                                Warning
                                            </p>
                                        </div>
                                        <p className="text-[#BC4C2E] text-[0.75rem]">
                                            {parse(dialog.warning)}
                                        </p>
                                    </div>
                                )}
                                <div className="flex justify-center mt-8">
                                    <Button
                                        theme="dark"
                                        onClick={() => {
                                            if(dialog.onCancel ){ dialog.onCancel() }
                                            close()
                                        }}
                                    >
                                        <Icon name="close" />
                                        No, Cancel
                                    </Button>
                                    &nbsp;
                                    <Button

                                        theme="danger"
                                        onClick={() => {
                                            if(dialog.onConfirm) { dialog.onConfirm()} 
                                            close()
                                        }}
                                    >
                                        <Icon name="delete" size={1} />
                                        Yes, Delete
                                    </Button>
                                </div>
                            </>
                        )}
                    </>
                )}

                {dialog?.dialog == 'confirm' && (
                    <>
                        {dialog?.type == 'warn' && (
                            <>
                                <p className="font-bold text-center text-[1.333rem] leading-8">{dialog.title}</p>
                                <p className="py-4 text-center">{parse(dialog.message)}</p>
                                {dialog.warning && (
                                    <div className="mb-8 bg-[#FFE9D9] rounded-[0.333rem] text-center overflow-hidden px-4 py-2">
                                        <div className="flex items-center text-[#F23F44] justify-center mb-1">
                                            <Icon name="warning" />
                                            <p className="!text-[#F23F44] text-[0.75rem] font-bold">
                                                Warning
                                            </p>
                                        </div>
                                        <p className="text-[#BC4C2E] text-[0.75rem]">
                                            {parse(dialog.warning)}
                                        </p>
                                    </div>
                                )}
                                <div className="flex justify-center mt-8">
                                    <Button
                                        theme="dark"
                                        onClick={() => {
                                            if(dialog.onCancel ){ dialog.onCancel() }
                                            close()
                                        }}
                                    >
                                        <Icon name="close" />
                                        No, Cancel
                                    </Button>
                                    &nbsp;
                                    <Button
                                        onClick={() => {
                                            if(dialog.onConfirm) { dialog.onConfirm()} 
                                            close()
                                        }}
                                    >
                                        <Icon name="right" size={1} />
                                        Yes, Proceed
                                    </Button>
                                </div>
                            </>
                        )}
                    </>
                )}
 
                {dialog?.dialog == 'share' && (
                    <>
                        {dialog?.type == 'link' && (
                            <>
                                <p className="font-bold text-center text-[1.333rem] leading-8">{dialog.title}</p>
                                <p className="py-4 text-center">{parse(dialog.message)}</p>
                                <div className="flex items-center my-3 h-[3.042rem] bg-[#f4f4f4] border border-[#c1c1c1] rounded-[0.333rem] p-2">
                                    <p className="text-[0.75rem] text-[#808E96]">
                                        {dialog.link}
                                    </p>
                                </div>
                            </>
                        )}
                    </>
                )}
                {dialog?.dialog == 'successExperiment' && (
                    <>
                        <div className="flex justify-center -mt-[3rem]">
                            <img src="/assets/images/success.gif" className="w-[14rem]" />
                        </div>
 
                        <div className="text-center font-semibold -mt-[2rem]">
                            <p className="text-[1rem] mb-4">
                                Experiment Submitted Successfully
                            </p>
                            <p className="text-[1rem] mb-4">
                                Please proceed with Execution of your experiment!
                                <br />
                                Once it is completed, come back here to check the results
                            </p>
                        </div>
 
                        <div className="flex justify-center gap-2">
                            <Button
                                theme="secondary"
                                
                                onClick={() => {
                                    dialog.onButtonClick()
                                    close()
                                }}
                            >
                                {/* <Icon name="eye" /> */}
                                Back to Home
                            </Button>
                        </div>
                    </>
                )}
            </div>
            <form method="dialog" className="modal-backdrop">
                <button>close</button>
            </form>
        </dialog>
    )
}
 
export default Dialog